"use strict";
exports.__esModule = true;
exports.isFromSearch = void 0;
var search_list = [
    'www.2345.com',
    'www.hao774.com',
    'hao.360.com',
    'hao.360.cn',
    'www.so.com',
    'www.uc123.com',
    'laonian.baidu.com',
    'www.baidu.com',
    'site.baidu.com',
    'www.bing.com',
    'www.google.com',
    'firefoxchina.cn',
    'toutiao.com',
    'www.sogou.com',
    'sogou.com',
    'web.sogou.com',
    'cn.bing.com'
];
/**
 * 是否来自搜索引擎
 */
function isFromSearch() {
    var referer = document.referrer;
    if (referer) {
        var isfrom_1 = false;
        search_list.forEach(function (v) {
            if (referer.indexOf(v) >= 0)
                isfrom_1 = true;
        });
        return isfrom_1;
    }
    return false;
}
exports.isFromSearch = isFromSearch;
